module.exports = __webpack_public_path__ + "img/Pulau-Plastik-1110x450.2fa6dd26.png";